<div class="bloco">
  <h5 class="titulo">IRPF</h5>
  <div *ngIf="naoEncontrouRegistros">
      <div class="row">
        <div class="col-auto item">Nenhum registro encontrado <i class="far fa-frown"></i></div>
      </div>
  </div>
  <div *ngIf="naoSolicitou">
      <div class="row">
          <div class="col-auto item">Você não solicitou essa consulta.</div>
        <!-- <div class="col-auto item"><button (click)="consultar()" [disabled]="consultando" class="btn btn-primary"><i class="fas fa-search"></i> Você não solicitou essa consulta. {{txtButtonConsultar}}</button></div> -->
      </div>
  </div>
  <div *ngIf="dados.irpf">
    <div class="row">
        <table class="table table-sm ">
            <thead>
              <tr>
                <th>Situação</th>
                <th>Banco</th>
                <th>Agência</th>
                <th>Ano Base</th>
                <th>Data Crédito</th>
                <!-- <th>Atualizado há</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of dados.irpf">
                <td>{{row.situacao}}</td>
                <td>{{row.banco}}</td>
                <td>{{row.agencia}}</td>
                <td>{{row.ano_base}}</td>
                <td>{{row.data_credito}}</td>
                <!-- <td>{{row.recencia_meses}} mes(es)</td> -->
              </tr>
            </tbody>
          </table>
    </div>
  </div>
</div>
  
  